import recallServices from '../../../services/provider/recall'
import moment from 'moment'
export default {
    props: {
        id: {type: String, default: null},
        providerCommunicationId: {type: String, default: null},
        communicationName: {type: String, default: null},
        recallSentBy: {type: String, default: null},
        supplier_name: {type: String, default: null},
        distributorName: {type: String, default: null},
        provider_name: {type: String, default: null},
    },
    data() {
        return {
            item: null,
            responseFormData: null,
            bodyContent: '',
            subject: null,
            emailTemplate: null,
            comment: '',
            supplierRepBodyContent: ''
        }
    },
    methods: {
        forceRerenderInsert(val) {
            this.item = val
            this.$refs.modal.show()
            this.getResponseFormData()
        },
        getResponseFormData() {
            recallServices.getResponseFormData(this.id, this.providerCommunicationId).then(resp => {
                this.responseFormData = resp.data.d
                this.getEmailTemplate()
            })
        },
        getEmailTemplate() {
            recallServices.getEmail('RESPONSE_EMAIL').then(resp => {
                this.emailTemplate = resp.data.d
                this.bodyContent = /<body.*?>([\s\S]*)<\/body>/.exec(
                    this.emailTemplate.content
                )[1]
                this.subject = this.emailTemplate.subject
                this.subject = this.subject.replaceAll('${PRODUCT NAME}', this.responseFormData.recallName)
                this.bodyContent = this.bodyContent.replaceAll(
                    '<p style="margin-bottom: 0px; margin-top: 0px;">${ContactInfo}</p>',
                    ''
                )
                this.bodyContent = this.bodyContent.replaceAll('${Date}', moment().format('MM/DD/YYYY'))
                this.bodyContent = this.bodyContent.replaceAll('${InventoryStatus}', this.responseFormData.hadAffectedProductInventory ? 'found' : 'did not find')
                if(this.responseFormData.hadAffectedProductInventory) {
                    // Generate table rows for each product in the array
                    const productRows = (this.responseFormData.products || []).map(product => {
                        return `<tr><td>${product.description || ''}</td><td>${product.fields.find(field => field.field_name === 'Product Number')?.value?.valueText || ''}</td><td>${product.fields.find(field => field.field_name === 'Catalog Number')?.value?.valueText || ''}</td><td>${product.fields.find(field => field.field_name === 'Model')?.value?.valueText || ''}</td><td>${product.fields.find(field => field.field_name === 'Item Number')?.value?.valueText || ''}</td><td>${product.fields.find(field => field.field_name === 'Lot Number')?.value?.valueText || ''}</td><td>${product.fields.find(field => field.field_name === 'Serial Number')?.value?.valueText || ''}</td><td>${product.quantity == 0 ? '0' : (product.quantity || '')}</td><td>${product.unitOfMeasure || ''}</td></tr>`
                    }).join('')

                    // Replace the template row with actual product rows
                    this.bodyContent = this.bodyContent.replaceAll(
                        '<tr><td>${ProductDiscription}</td><td>${ProductNumber}</td><td>${CatalogNumber}</td><td>${ModelNumber}</td><td>${ItemNumber}</td><td>${LotNumber}</td><td>${SerialNumber}</td><td>${Quantity}</td><td>${UnitOfMeasure}</td></tr>',
                        productRows
                    )
                } else {
                    this.bodyContent = this.bodyContent.replaceAll('Products found in inventory:', '')
                    const productTable = '<table border="1" cellpadding="5" cellspacing="0" width="100%" style="display: none; border-collapse: collapse;"><thead><tr style="background-color: #f2f2f2;"><th>Product Name</th><th>Product Number</th><th>Catalog Number</th><th>Model Number</th><th>Item Number</th><th>Lot Number</th><th>Serial Number</th><th>Quantity</th><th>Unit of Measure (boxes, eaches, bottles, etc.)</th></tr></thead><tbody><tr><td>ProductDiscription</td><td>ProductNumber</td><td>CatalogNumber</td><td>ModelNumber</td><td>ItemNumber</td><td>LotNumber</td><td>SerialNumber</td><td>Quantity</td><td>UnitOfMeasure</td></tr></tbody></table>'
                    this.bodyContent = this.bodyContent.replaceAll(
                        '<table border="1" cellpadding="5" cellspacing="0" width="100%" style="display: ${displayOld}; border-collapse: collapse;"><thead><tr style="background-color: #f2f2f2;"><th>Product Name</th><th>Product Number</th><th>Catalog Number</th><th>Model Number</th><th>Item Number</th><th>Lot Number</th><th>Serial Number</th><th>Quantity</th><th>Unit of Measure (boxes, eaches, bottles, etc.)</th></tr></thead><tbody><tr><td>${ProductDiscription}</td><td>${ProductNumber}</td><td>${CatalogNumber}</td><td>${ModelNumber}</td><td>${ItemNumber}</td><td>${LotNumber}</td><td>${SerialNumber}</td><td>${Quantity}</td><td>${UnitOfMeasure}</td></tr></tbody></table>',
                        productTable
                    )
                }
                if(this.responseFormData.affectedProductStatus == 'not-applicable') {
                    this.bodyContent = this.bodyContent.replaceAll('<p style="display: ${displayOld};">Affected product(s) were ${DispositionStatus}.</p>', '')
                } else {
                    this.bodyContent = this.bodyContent.replaceAll('${DispositionStatus}', this.responseFormData.affectedProductStatus)
                }
                this.bodyContent = this.bodyContent.replaceAll('${ReturnKitInstruction}', this.responseFormData.needReturnKit === 'yes' ? 'Please send a return kit' : '')
                if(this.responseFormData.facilities.length > 0) {
                    const facilityRows = this.responseFormData.facilities.map((facility, index) => {
                        if(index > 0) {
                            return `<p style="margin-top: 15px; margin-bottom: 0px;"><br />${facility.providerName || ''}<br />${facility.streetAddress || ''}<br />${facility.city || ''}, ${facility.state || ''} ${facility.zipCode || ''}<br />${this.responseFormData.accountCustomerNumber || ''}</p>`
                        }
                        return `<p style=""><strong>Facility information:</strong><br />${facility.providerName || ''}<br />${facility.streetAddress || ''}<br />${facility.city || ''}, ${facility.state || ''} ${facility.zipCode || ''}<br />${this.responseFormData.accountCustomerNumber || ''}</p>`
                    }).join('')

                    this.bodyContent = this.bodyContent.replaceAll('<p style="display: ${displayOld};"><strong>Facility information:</strong><br />${FacilityProviderName}<br />${StreetAddress}<br />${City}, ${State} ${ZipCode}<br />${AccountCustomerNumber}</p>', facilityRows)
                }
                this.bodyContent = this.bodyContent.replaceAll('${SenderName}', this.responseFormData.contactName || '')
                this.bodyContent = this.bodyContent.replaceAll('${SenderTitle}', this.responseFormData.contactTitle || '')
                this.bodyContent = this.bodyContent.replaceAll('${SenderEmail}', this.responseFormData.contactEmail || '')
                this.bodyContent = this.bodyContent.replaceAll('${SenderPhone}', this.responseFormData.contactPhone || '')

                this.supplierRepBodyContent = this.bodyContent
                this.bodyContent = this.bodyContent.replaceAll('<p style="display: ${displayOld};">${ProviderName} is responding to recalling firms recall of ${ProductName} dated ${RecallDate}. This is for your information only.</p>', '')
                this.bodyContent = this.bodyContent.replaceAll('${RecallingFirm}', this.recallSentBy === 'Distributor' ? this.distributorName || this.supplier_name : this.supplier_name)
                this.bodyContent = this.bodyContent.replaceAll('${ProductName}', this.responseFormData.recallName || '')
                this.bodyContent = this.bodyContent.replaceAll('${RecallDate}', moment(this.responseFormData.recallDate).format('MM/DD/YYYY') || '')
                this.bodyContent = this.bodyContent.replaceAll('${ProviderName}', this.provider_name || '')

                this.supplierRepBodyContent = this.supplierRepBodyContent.replaceAll('<p style="display: ${displayOld};">Please accept this email as our acknowledgement and response to the event affecting ${ProductName} dated ${RecallDate}.</p>', '')
                this.supplierRepBodyContent = this.supplierRepBodyContent.replaceAll('${RecallingFirm}', 'Representative')
                this.supplierRepBodyContent = this.supplierRepBodyContent.replaceAll('${ProductName}', this.responseFormData.recallName || '')
                this.supplierRepBodyContent = this.supplierRepBodyContent.replaceAll('${RecallDate}', moment(this.responseFormData.recallDate).format('MM/DD/YYYY') || '')
                this.supplierRepBodyContent = this.supplierRepBodyContent.replaceAll('${ProviderName}', this.provider_name || '')
            })
        },
        sendResponseEmail() {
            recallServices.providerResponseMail({
                communicationId: this.id,
                providerCommunicationId: this.providerCommunicationId,
                comment: this.comment,
                contactInfoContent: this.bodyContent,
                subject: this.subject,
                email: this.responseFormData.recallingFirmEmail,
                supplierRepContent: this.supplierRepBodyContent
            }, true).then(resp => {
                if (!resp.error){
                    this.cancel()
                    this.$emit('onSubmit','yes')
                    this._showToast('Recall response has been sent.', {variant: 'success'})
                }
            })
        },
        cancel() {
            this.$refs.modal.hide()
            this.$emit('onSubmit','no')
        },
    },
    computed: {
        form() {
            return {
                title: 'Would you like to send recall response to recalling firm?',
            }
        },
    },
}